import { Container, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { FaAppStoreIos, FaGooglePlay } from "react-icons/fa";

const Download = () => {
  return (
    <Container>
      <Helmet>
        <title>
           تطبيق أكواد: تحميل التطبيق
        </title>
      </Helmet>
      <Card className="my-5 text-right">
        <Card.Header as="h5">
          حمل تطبيق أكواد على جوالك، واجعل كل أكواد الخصم متوفرة بين يدينك بضغطة
          زر:
        </Card.Header>
        <Card.Body>
          <Card.Title>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://apps.apple.com/us/app/%D8%A3%D9%83%D9%88%D8%A7%D8%AF/id1503139481?ls=1"
            >
              <FaAppStoreIos size="1em" className="ml-2" />
              آي فون
            </a>
          </Card.Title>
          <Card.Title>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://play.google.com/store/apps/details?id=www.akoad.app"
            >
              <FaGooglePlay size="1em" className="ml-2" />
              أندرويد
            </a>
          </Card.Title>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Download;
